/* Phase 57 · Back in stock sign-up (Klaviyo).
   1. Product cards: [data-fds-notify-open] (snippets/fds-notify-button)
      opens one shared dialog with size chips + email.
   2. PDP: Broadcast's sold-out notification form ([data-notification-form],
      snippets/notification-form) is taken over so it posts to Klaviyo too,
      instead of emailing the store inbox. If Klaviyo rejects the variant,
      the PDP form falls back to its native submit so no sign-up is lost.
   Klaviyo sends the emails from its Back in Stock flow. Without that flow
   live, sign-ups are stored but nobody is emailed.
   Docs: developers.klaviyo.com/en/docs/how_to_set_up_custom_back_in_stock */
(function () {
  if (window.fdsNotify) return;
  var COMPANY = (document.querySelector('meta[name="fds-klaviyo-company"]') || {}).content || 'UE2LHy';
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function subscribe(email, variantId) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function (r) {
      if (r.status === 202 || r.status === 200 || r.status === 201) return { ok: true };
      return r.text().then(function (t) { return { ok: false, status: r.status, body: t }; });
    }, function () { return { ok: false, status: 0 }; });
  }

  function track(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  /* ── Card dialog ─────────────────────────────────────────────── */
  var dlg, els = {}, state = {}, lastTrigger = null;

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'fds-notify';
    dlg.setAttribute('aria-labelledby', 'fds-notify-title');
    dlg.innerHTML =
      '<form class="fds-notify__panel" novalidate>' +
        '<button type="button" class="fds-notify__close" aria-label="Close">&times;</button>' +
        '<p class="fds-notify__eyebrow">Sold out</p>' +
        '<h2 class="fds-notify__title" id="fds-notify-title">Get notified</h2>' +
        '<p class="fds-notify__product"></p>' +
        '<fieldset class="fds-notify__sizes"><legend class="fds-notify__label">Size</legend><div class="fds-notify__chips"></div></fieldset>' +
        '<label class="fds-notify__label" for="fds-notify-email">Email</label>' +
        '<input class="fds-notify__email" id="fds-notify-email" type="email" name="email" autocomplete="email" placeholder="you@example.com" required>' +
        '<p class="fds-notify__error" role="alert" hidden></p>' +
        '<button type="submit" class="fds-notify__submit btn btn--solid btn--black">Notify me</button>' +
        '<p class="fds-notify__note">One email when it’s back. That’s it.</p>' +
        '<div class="fds-notify__done" hidden>' +
          '<p class="fds-notify__done-title">You’re on the list.</p>' +
          '<p class="fds-notify__done-copy"></p>' +
        '</div>' +
      '</form>';
    document.body.appendChild(dlg);
    els.form = dlg.querySelector('form');
    els.product = dlg.querySelector('.fds-notify__product');
    els.sizes = dlg.querySelector('.fds-notify__sizes');
    els.chips = dlg.querySelector('.fds-notify__chips');
    els.email = dlg.querySelector('.fds-notify__email');
    els.error = dlg.querySelector('.fds-notify__error');
    els.submit = dlg.querySelector('.fds-notify__submit');
    els.done = dlg.querySelector('.fds-notify__done');
    els.doneCopy = dlg.querySelector('.fds-notify__done-copy');
    els.note = dlg.querySelector('.fds-notify__note');
    dlg.querySelector('.fds-notify__close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('fds-notify-open');
      if (lastTrigger) { try { lastTrigger.focus(); } catch (e) {} }
    });
    els.form.addEventListener('submit', onSubmit);
  }

  function showError(msg) { els.error.textContent = msg; els.error.hidden = !msg; }

  function open(btn) {
    if (!dlg) build();
    lastTrigger = btn;
    var variants = [];
    try { variants = JSON.parse(btn.getAttribute('data-variants') || '[]'); } catch (e) {}
    state = { title: btn.getAttribute('data-product-title') || '', variants: variants, variantId: null, size: '' };
    els.product.textContent = state.title;
    els.form.classList.remove('is-done');
    els.done.hidden = true;
    els.submit.hidden = false; els.note.hidden = false; els.email.hidden = false;
    els.email.previousElementSibling.hidden = false;
    els.submit.disabled = false;
    showError('');
    els.chips.innerHTML = '';
    var named = variants.filter(function (v) { return v.title; });
    if (named.length > 1) {
      els.sizes.hidden = false;
      named.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fds-notify__chip';
        b.textContent = v.title;
        b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          Array.prototype.forEach.call(els.chips.children, function (c) { c.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          state.variantId = v.id; state.size = v.title;
          showError('');
        });
        els.chips.appendChild(b);
      });
    } else {
      els.sizes.hidden = true;
      if (variants[0]) { state.variantId = variants[0].id; state.size = variants[0].title || ''; }
    }
    try { var saved = localStorage.getItem('fds-notify-email'); if (saved && !els.email.value) els.email.value = saved; } catch (e) {}
    document.documentElement.classList.add('fds-notify-open');
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    (els.sizes.hidden ? els.email : els.chips.firstChild || els.email).focus();
    track('fds:notify:open', { title: state.title });
  }

  function close() { if (dlg.open) dlg.close(); else dlg.removeAttribute('open'); }

  function onSubmit(e) {
    e.preventDefault();
    var email = (els.email.value || '').trim();
    if (!state.variantId) { showError('Pick a size first.'); return; }
    if (!EMAIL_RE.test(email)) { showError('Enter a valid email.'); els.email.focus(); return; }
    showError('');
    els.submit.disabled = true;
    subscribe(email, state.variantId).then(function (res) {
      els.submit.disabled = false;
      if (!res.ok) {
        showError(res.status === 400 ? 'That email didn’t work. Check it and try again.' : 'Couldn’t sign you up right now. Try again from the product page.');
        track('fds:notify:error', { status: res.status });
        return;
      }
      try { localStorage.setItem('fds-notify-email', email); } catch (err) {}
      els.form.classList.add('is-done');
      els.sizes.hidden = true; els.submit.hidden = true; els.note.hidden = true;
      els.email.hidden = true; els.email.previousElementSibling.hidden = true;
      els.doneCopy.textContent = 'We’ll email ' + email + ' when ' + state.title + (state.size ? ' in ' + state.size : '') + ' is back.';
      els.done.hidden = false;
      els.done.setAttribute('tabindex', '-1'); els.done.focus();
      track('fds:notify:subscribed', { title: state.title, size: state.size, variant: state.variantId });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fds-notify-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    open(btn);
  }, true);

  /* ── PDP: take over Broadcast's sold-out notification form ───── */
  function pdpVariantId(form) {
    var scope = form.closest('[id^="shopify-section"]') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = input && input.value;
    if (!id) { var m = location.search.match(/[?&]variant=(\d+)/); id = m && m[1]; }
    return id;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-notification-form]') || form.dataset.fdsNative === '1') return;
    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var variantId = pdpVariantId(form);
    if (!email || !variantId) return; /* let Broadcast handle it */
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    subscribe(email, variantId).then(function (res) {
      if (btn) btn.disabled = false;
      if (!res.ok) {
        /* Fallback: native contact form to the store inbox. */
        form.dataset.fdsNative = '1';
        track('fds:notify:error', { status: res.status, where: 'pdp' });
        form.submit();
        return;
      }
      try { localStorage.setItem('fds-notify-email', email); } catch (err) {}
      var box = form.querySelector('.product__notification__form');
      var msg = document.createElement('div');
      msg.className = 'product__notification__message fds-notify__pdp-done';
      msg.setAttribute('role', 'status');
      msg.innerHTML = '<p><strong>You’re on the list.</strong> We’ll email you when it’s back.</p>';
      if (box) box.replaceWith(msg); else form.appendChild(msg);
      track('fds:notify:subscribed', { variant: variantId, where: 'pdp' });
    });
  }, true);

  window.fdsNotify = { open: open, subscribe: subscribe };
})();
